var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.2 10a6.8 6.8 0 1 1 13.6 0 6.8 6.8 0 0 1-13.6 0M10 1.8a8.2 8.2 0 1 0 0 16.4 8.2 8.2 0 0 0 0-16.4m-.685 4.203a.86.86 0 0 1 .618-.252c.24 0 .45.085.617.256a.88.88 0 0 1 .257.622v.004a.85.85 0 0 1-.253.616l-.002.002a.86.86 0 0 1-.619.247.87.87 0 0 1-.616-.245l-.005-.004a.85.85 0 0 1-.253-.616c0-.243.084-.457.253-.628zM7.987 9.41a.7.7 0 0 1 .7-.7H10.1a.7.7 0 0 1 .7.7v3.439h.681a.7.7 0 1 1 0 1.4H8.52a.7.7 0 1 1 0-1.4h.88V10.11h-.713a.7.7 0 0 1-.7-.7",
    clipRule: "evenodd"
  })));
};
export default SvgInfo;